interface PasswordStrengthProps {
  password: string;
}

export function scorePassword(pw: string): {
  score: number; // 0..3
  label: "Empty" | "Weak" | "OK" | "Strong";
} {
  if (!pw) return { score: 0, label: "Empty" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Za-z]/.test(pw) && /\d/.test(pw)) score++;
  if (pw.length >= 12 && /[^A-Za-z0-9]/.test(pw)) score++;
  if (pw.length >= 16) score = Math.min(3, score + 1);
  const label = (["Empty", "Weak", "OK", "Strong"] as const)[score] ?? "Strong";
  return { score, label };
}

export function PasswordStrength({ password }: PasswordStrengthProps) {
  const { score, label } = scorePassword(password);
  const bars = [0, 1, 2];
  const colors = ["bg-border", "bg-oxblood/40", "bg-oxblood/70", "bg-oxblood"];
  return (
    <div
      data-testid="password-strength"
      data-strength={label.toLowerCase()}
      className="flex items-center gap-3 mt-2"
    >
      <div className="flex gap-1.5 flex-1">
        {bars.map((i) => (
          <span
            key={i}
            className={`h-1 flex-1 rounded-none transition-colors ${
              i < score ? colors[score] : "bg-border"
            }`}
          />
        ))}
      </div>
      <span className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground w-12 text-right">
        {label}
      </span>
    </div>
  );
}
